import { Participant, RemoteParticipant } from "twilio-video";

export const convertParticipantsMapToArray = (
  participants: Map<Participant.SID, RemoteParticipant>,
) => {
  return Array.from(participants).map(([_, participant]) => participant);
};
